import { mergeClassNames } from '@/lib/utils';

const XCloseIcon = ({ className, ...props }: React.ComponentProps<'svg'>) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={mergeClassNames('h-4 w-4 text-red-400', className)}
    {...props}
  >
    <path
      d="M16.3876 4.95907C16.7596 4.58714 16.7596 3.98413 16.3876 3.6122C16.0157 3.24027 15.4127 3.24027 15.0408 3.6122L9.99992 8.65305L4.95907 3.6122C4.58714 3.24027 3.98413 3.24027 3.6122 3.6122C3.24027 3.98413 3.24027 4.58714 3.6122 4.95907L8.65305 9.99992L3.6122 15.0408C3.24027 15.4127 3.24027 16.0157 3.6122 16.3876C3.98413 16.7596 4.58714 16.7596 4.95907 16.3876L9.99992 11.3468L15.0408 16.3876C15.4127 16.7596 16.0157 16.7596 16.3876 16.3876C16.7596 16.0157 16.7596 15.4127 16.3876 15.0408L11.3468 9.99992L16.3876 4.95907Z"
      fill="currentColor"
    />
  </svg>
);

export default XCloseIcon;
